document.addEventListener('DOMContentLoaded',function(){
  var body=document.body;
  if(!body||!body.classList.contains('template-product')) return;
  var mediaWrapper=document.querySelector('.main-product-template .product__media-wrapper');
  if(!mediaWrapper) return;
  var accordions=[].slice.call(document.querySelectorAll('.main-product-template > .page-width > .row > .product__accordion, .main-product-template > .page-width > .row > .accordion'));
  if(!accordions.length){
    accordions=[].slice.call(document.querySelectorAll('.main-product-template .row > .product__accordion, .main-product-template .row > .accordion')).filter(function(el){return !el.closest('.product__info-container')&&!el.closest('.product__media-wrapper');});
  }
  accordions.forEach(function(el,index){
    var title=(el.textContent||'').toLowerCase();
    var isDescription=title.indexOf('description')>-1;
    if(index===0 || isDescription){
      el.classList.add('cbdh-description-under-media');
      mediaWrapper.appendChild(el);
      var details=el.querySelector('details');
      if(details){details.removeAttribute('open');}
    }else{
      el.remove();
    }
  });
  document.querySelectorAll('.product__media-wrapper .thumbnail-list__item').forEach(function(item){
    item.style.height='auto';
  });
});
